import React from "react";
import CryptoJS from "crypto-js";
import Cookies from "js-cookie";

class SSOCookieSetter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      successMessage: "",
      errorMessage: "",
    };
  }

  componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search);
    const encryptedData = urlParams.get("data");

    if (!encryptedData) {
      this.setState({ errorMessage: "Missing SSO data." });
      return;
    }

    try {
      const jsonStr = atob(encryptedData);
      const decrypted = JSON.parse(jsonStr);
      const selectedMenu = (decrypted.selected_menu || "").toLowerCase();

      // console.log("✅ Decrypted SSO Token:", decrypted);

      // Clear only agent-specific cookies (not all cookies on the domain)
      const AGENT_COOKIE_NAMES = [
        "tkn__", "acn__", "eml__", "comp_nme__", "name__",
        "phone__", "title__", "usertype__", "subpoenatype__",
        "userlogo__", "useracct__", "usertkn__", "decimalPoint__",
        "billing_decimalPoint__", "menu__", "residentifier__",
        "restitle__", "reslogo__", "ressig__", "restkn__", "resacct__",
        "agent_session_start__", "agent_session_expiry__",
      ];
      AGENT_COOKIE_NAMES.forEach((key) => Cookies.remove(key, { path: "/" }));

      // Set encrypted cookies (same structure as formSubmit)
      Cookies.set(
        "tkn__",
        CryptoJS.AES.encrypt(
          decrypted.token,
          process.env.REACT_APP_SIGNATURE
        ).toString()
      );
      Cookies.set(
        "acn__",
        CryptoJS.AES.encrypt(
          decrypted.accountno,
          process.env.REACT_APP_SIGNATURE
        ).toString()
      );
      Cookies.set(
        "eml__",
        CryptoJS.AES.encrypt(
          decrypted.email,
          process.env.REACT_APP_SIGNATURE
        ).toString()
      );
      Cookies.set(
        "comp_nme__",
        CryptoJS.AES.encrypt(
          decrypted.comp_name,
          process.env.REACT_APP_SIGNATURE
        ).toString()
      );
      Cookies.set(
        "name__",
        CryptoJS.AES.encrypt(
          decrypted.name,
          process.env.REACT_APP_SIGNATURE
        ).toString()
      );
      Cookies.set(
        "phone__",
        CryptoJS.AES.encrypt(
          decrypted.phone || "",
          process.env.REACT_APP_SIGNATURE
        ).toString()
      );
      Cookies.set(
        "title__",
        CryptoJS.AES.encrypt(
          decrypted.title || "",
          process.env.REACT_APP_SIGNATURE
        ).toString()
      );
      Cookies.set(
        "usertype__",
        CryptoJS.AES.encrypt(
          decrypted.user_type,
          process.env.REACT_APP_SIGNATURE
        ).toString()
      );
      Cookies.set(
        "subpoenatype__",
        CryptoJS.AES.encrypt(
          decrypted.admin_type || "No",
          process.env.REACT_APP_SIGNATURE
        ).toString()
      );
      Cookies.set(
        "userlogo__",
        CryptoJS.AES.encrypt(
          decrypted.user_logo || "",
          process.env.REACT_APP_SIGNATURE
        ).toString()
      );
      Cookies.set(
        "useracct__",
        CryptoJS.AES.encrypt(
          decrypted.user_accountno || decrypted.accountno,
          process.env.REACT_APP_SIGNATURE
        ).toString()
      );
      Cookies.set(
        "usertkn__",
        CryptoJS.AES.encrypt(
          decrypted.sub_user_token || "",
          process.env.REACT_APP_SIGNATURE
        ).toString()
      );
      Cookies.set(
        "decimalPoint__",
        CryptoJS.AES.encrypt(
          (decrypted.decimalPoint || 2).toString(),
          process.env.REACT_APP_SIGNATURE
        ).toString()
      );
      Cookies.set(
        "billing_decimalPoint__",
        CryptoJS.AES.encrypt(
          (decrypted.billing_decimalPoint || 2).toString(),
          process.env.REACT_APP_SIGNATURE
        ).toString()
      );
      Cookies.set(
        "menu__",
        CryptoJS.AES.encrypt(
          JSON.stringify(decrypted.menu || []),
          process.env.REACT_APP_SIGNATURE
        ).toString()
      );

      // console.log("✅ All SSO cookies set.");

      this.setState({
        successMessage: "Account authenticated successfully. Redirecting...",
      });

      let redirectPath = "/dashboard";

      switch (selectedMenu) {
        case "clients":
          redirectPath = "/clients";
          break;
        case "forms":
          redirectPath = "/forms";
          break;
        case "orders":
          redirectPath = "/SalesOrders";
          break;
        case "settings":
          redirectPath = "/upgrades/general_settings";
          break;
        case "agents":
          redirectPath = "/agents";
          break;
        case "agreements":
          redirectPath = "/clients/agreements";
          break;
        case "quotations":
          redirectPath = "/Quotations";
          break;
        case "sales":
          redirectPath = "/SalesOrders";
          break;
        case "reports":
          redirectPath = "/adminReports";
          break;
        case "signed agreements":
          redirectPath = "/signed/clientagreements";
          break;
        case "integrations":
          redirectPath = "/Integrations";
          break;
        case "forms":
          redirectPath = "/forms";
          break;
        case "subpoena":
          redirectPath = "/Compliance";
          break;
        case "documents":
          redirectPath = "/Collaterals";
          break;
        case "forms":
          redirectPath = "/forms";
          break;
        case "forms":
          redirectPath = "/forms";
          break;
        case "products & services":
          redirectPath = "/services";
          break;
        case "support":
          redirectPath = "/support/adminSupport";
          break;
        case "dashboard":
        default:
          redirectPath = "/dashboard";
          break;
      }

      setTimeout(() => {
        window.location.replace(`${window.location.origin}${redirectPath}`);
      }, 1500);
    } catch (err) {
      console.error("❌ Cookie set failed:", err);
      this.setState({ errorMessage: "Invalid SSO token. Please login again." });
      setTimeout(() => {
        window.location.replace("/login");
      }, 2000);
    }
  }

  render() {
    const { successMessage, errorMessage } = this.state;

    return (
      <div className="nk-content">
        <div className="container-fluid">
          <div className="nk-content-inner">
            <div className="nk-content-body">
              {/* Error Alert */}
              {errorMessage !== "" && (
                <div className="example-alert">
                  <div className="alert alert-pro alert-danger">
                    <div className="alert-text">
                      <h4>Error</h4>
                      <p>{errorMessage}</p>
                    </div>
                  </div>
                </div>
              )}

              {/* Success Alert */}
              {successMessage !== "" && (
                <div className="example-alert">
                  <div className="alert alert-pro alert-success">
                    <div className="alert-text">
                      <h4>Success</h4>
                      <p>{successMessage}</p>
                    </div>
                  </div>
                </div>
              )}

              {/* Spinner */}
              <div className="text-center" style={{ marginTop: "20%" }}>
                <div className="spinner-border text-primary" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SSOCookieSetter;
